export const BRAND_CODE = "NG";
export const SITE_CODE = "NG";

export function isProd() {
  switch (process.env.NEXT_PUBLIC_ENVIRONMENT) {
    case "local":
    case "dev":
    case "stage":
      return false;
    case "preprod":
    case "prod":
      return true;
    default:
      return false;
  }
}
